/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Stepper, StepperProps } from 'bold-ui'
import { useMemo } from 'react'

interface VerticalStepperProps extends StepperProps {
  gap?: number
}

export function VerticalStepper(props: Readonly<VerticalStepperProps>) {
  const { gap = 0, style, ...rest } = props

  const styles = useMemo(() => createStyles(gap), [gap])

  return <Stepper style={css(styles.verticalStepper, style)} {...rest} />
}

const createStyles = (gap: number) => ({
  verticalStepper: css`
    flex-direction: column;
    & > * {
      &:not(:last-child) {
        padding-bottom: ${gap}rem;
      }
    }
  `,
})
